
// import React, { useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError('');
//     setIsLoading(true);

//     try {
//       const response = await axios.post('https://customersupport-jhy9.onrender.com/api/auth/login', {
//         email,
//         password,
//       });

//       const { token } = response.data;

//       if (token) {
//         localStorage.setItem('accessToken', token);
//         navigate('/companies');
//       } else {
//         setError('Invalid login response');
//       }
//     } catch (err) {
//       console.error(err);
//       setError('Login failed. Please check your credentials.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-blue-100 py-8 px-4">
//       <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden">
//         {/* Header Section */}
//         <div className="bg-gradient-to-r from-indigo-600 to-blue-600 px-6 py-8 text-center">
//           <h1 className="text-3xl font-bold text-white mb-2">CRM Dashboard</h1>
//           <p className="text-indigo-100">Sign in to access your account</p>
//         </div>
        
//         {/* Form Section */}
//         <form onSubmit={handleLogin} className="px-8 py-8">
//           {error && (
//             <div className="mb-6 p-3 bg-red-100 text-red-700 rounded-md border border-red-200 flex items-center">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
//                 <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
//               </svg>
//               {error}
//             </div>
//           )}
          
//           <div className="mb-6">
//             <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
//               Email Address
//             </label>
//             <div className="relative">
//               <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
//                 </svg>
//               </div>
//               <input
//                 id="email"
//                 type="email"
//                 value={email}
//                 required
//                 onChange={(e) => setEmail(e.target.value)}
//                 autoFocus
//                 className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
//                 placeholder="Enter your email"
//               />
//             </div>
//           </div>
          
//           <div className="mb-6">
//             <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
//               Password
//             </label>
//             <div className="relative">
//               <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//                 </svg>
//               </div>
//               <input
//                 id="password"
//                 type="password"
//                 value={password}
//                 required
//                 onChange={(e) => setPassword(e.target.value)}
//                 className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
//                 placeholder="Enter your password"
//               />
//             </div>
//           </div>
          
//           <div className="flex items-center justify-between mb-6">
//             <div className="flex items-center">
//               <input
//                 id="remember-me"
//                 name="remember-me"
//                 type="checkbox"
//                 className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
//               />
//               <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">
//                 Remember me
//               </label>
//             </div>
            
//             <div className="text-sm">
//               <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
//                 Forgot your password?
//               </a>
//             </div>
//           </div>
          
//           <button
//             type="submit"
//             disabled={isLoading}
//             className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200 ${isLoading ? 'opacity-75 cursor-not-allowed' : ''}`}
//           >
//             {isLoading ? (
//               <>
//                 <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                 </svg>
//                 Signing in...
//               </>
//             ) : (
//               'Sign in'
//             )}
//           </button>
          
//           <div className="mt-6 text-center">
//             <p className="text-sm text-gray-600">
//               Don't have an account?{' '}
//               <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
//                 Contact administrator
//               </a>
//             </p>
//           </div>
//         </form>
        
//         {/* Footer */}
//         <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
//           <p className="text-xs text-gray-500 text-center">
//             &copy; {new Date().getFullYear()} CRM Dashboard. All rights reserved.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("superadmin"); // "superadmin" | "company"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      let url = "";

      if (activeTab === "superadmin") {
        url = "https://customersupport-jhy9.onrender.com/api/auth/login";
      } else if (activeTab === "company") {
        url = "https://customersupport-jhy9.onrender.com/api/companies/login";
      }

      const response = await axios.post(url, { email, password });

      console.log("Login success:", response.data);

      // Save token
      localStorage.setItem("accessToken", response.data.token);

      if (activeTab === "superadmin") {
        navigate("/companies"); // superadmin → go to companies management
      } else {
        localStorage.setItem("companyId", response.data.company?._id); // save logged-in company ID
        navigate("/departments"); // company → go to departments page
      }
    } catch (err) {
      console.error("Login error:", err.response?.data || err.message || err);
      setError("Invalid email or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-indigo-900 to-blue-900 py-8 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl overflow-hidden">
        
        {/* Tabs */}
        <div className="flex">
          <button
            className={`flex-1 py-3 text-center font-semibold ${
              activeTab === "superadmin"
                ? "bg-gradient-to-r from-purple-600 to-indigo-600 text-white"
                : "bg-gray-100 text-gray-600"
            }`}
            onClick={() => setActiveTab("superadmin")}
          >
            Super Admin Login
          </button>
          <button
            className={`flex-1 py-3 text-center font-semibold ${
              activeTab === "company"
                ? "bg-gradient-to-r from-purple-600 to-indigo-600 text-white"
                : "bg-gray-100 text-gray-600"
            }`}
            onClick={() => setActiveTab("company")}
          >
            Company Login
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin} className="px-8 py-8">
          {error && (
            <div className="mb-6 p-3 bg-red-50 text-red-700 rounded-md border border-red-200">
              {error}
            </div>
          )}

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {activeTab === "superadmin" ? "Admin Email" : "Company Email"}
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder={
                activeTab === "superadmin"
                  ? "admin@example.com"
                  : "company@example.com"
              }
              disabled={loading}
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Enter your password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 px-4 rounded-md text-white font-medium shadow-md bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 transition-all ${
              loading ? "opacity-75 cursor-not-allowed" : ""
            }`}
          >
            {loading
              ? "Authenticating..."
              : activeTab === "superadmin"
              ? "Login as Super Admin"
              : "Login as Company"}
          </button>
        </form>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 text-center">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} Enterprise Admin System. Access
            is monitored and logged.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
